<template>
  <PartsPageNav :items="breadcrumbItems" />

  <main class="main_welcome">
    <PartsLayoutCol2>
      <template #sidebar>
        <OrganismsLayoutsSidebar />
      </template>

      <OrganismsWelcome :title="pageTitle" />
    </PartsLayoutCol2>
  </main>

  <OrganismsSupport />
</template>

<script setup lang="ts">
/**
 * 初めての方へ。支給デザイン `welcome.html` の `main.main_welcome` に対応する。
 *
 * **`PartsLayoutContainer` はページ側に置かない。** 支給は `col2-wrapper` を `main` 直下に置き、
 * `.container` は `sec_welcome` の中に2つ入れ子で持つ（見出し用と本文用）。
 * 間の `welcome-head` だけ枠の外に出して画像を全幅で敷くための組み方なので、
 * `OrganismsWelcome` 側で `.container` を持たせる。
 *
 * **`pageTitle` ひとつでブラウザタブ・パンくず末尾・見出しを固定する**（決定#66・§1.5）。
 *
 * **サポート導線は `</main>` の後に置く**（§6 の要13ルート。`main` に `max-width: 1200px` が
 * 掛かっているので中に入れると全幅の帯が切れる）。
 */
import type { BreadcrumbType } from '@/types/domains/index';

const pageTitle: string = '初めての方へ';
const breadcrumbItems: BreadcrumbType.Breadcrumb[] = [
  { text: 'トップ', href: '/' },
  { text: pageTitle, href: null },
];

useSeoMeta({
  title: `${pageTitle}｜オリエンタルバイオ公式オンラインショップ`,
  description:
    'オリエンタルバイオ公式オンラインショップの「初めての方へ」。会員登録・定期コース・お買い物ガイド・よくあるご質問のご案内。健康食品のラフィーネ-アルファやラフィーネエパゴールド、業界初のオールインワン夜用サプリメントのアレルナイトプラスなど、いつまでも健康で美しくあるためのサプリメントや食品を販売',
  keywords: '初めての方へ,オリエンタルバイオ,orientalbio,健康食品,サプリメント,公式',
});
</script>
